import React from "react";

const plusIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_459_278)">
      <path
        d="M9.96094 19.9219C11.3216 19.9219 12.6026 19.6615 13.8037 19.1406C15.0049 18.6198 16.0645 17.9004 16.9824 16.9824C17.9004 16.0645 18.6198 15.0049 19.1406 13.8037C19.6615 12.6026 19.9219 11.3216 19.9219 9.96094C19.9219 8.60026 19.6615 7.31933 19.1406 6.11816C18.6198 4.91699 17.9004 3.85742 16.9824 2.93945C16.0645 2.02148 15.0033 1.30208 13.7988 0.78125C12.5944 0.260417 11.3119 0 9.95117 0C8.5905 0 7.30957 0.260417 6.1084 0.78125C4.90723 1.30208 3.84928 2.02148 2.93457 2.93945C2.01986 3.85742 1.30208 4.91699 0.78125 6.11816C0.260417 7.31933 0 8.60026 0 9.96094C0 11.3216 0.260417 12.6026 0.78125 13.8037C1.30208 15.0049 2.02148 16.0645 2.93945 16.9824C3.85742 17.9004 4.91699 18.6198 6.11816 19.1406C7.31933 19.6615 8.60026 19.9219 9.96094 19.9219Z"
        fill="black"
        fill-opacity="0.41"
      />
      <path
        d="M5.19531 9.9707C5.19531 9.71679 5.27669 9.51009 5.43945 9.35059C5.60221 9.19108 5.81055 9.11133 6.06445 9.11133H9.12109V6.05469C9.12109 5.80078 9.19759 5.59245 9.35059 5.42969C9.50359 5.26693 9.70378 5.18555 9.95117 5.18555C10.2051 5.18555 10.4118 5.26693 10.5713 5.42969C10.7308 5.59245 10.8105 5.80078 10.8105 6.05469V9.11133H13.877C14.1309 9.11133 14.3376 9.19108 14.4971 9.35059C14.6566 9.51009 14.7363 9.71679 14.7363 9.9707C14.7363 10.2181 14.6549 10.4183 14.4922 10.5713C14.3294 10.7243 14.1243 10.8008 13.877 10.8008H10.8105V13.8672C10.8105 14.1211 10.7308 14.3278 10.5713 14.4873C10.4118 14.6468 10.2051 14.7266 9.95117 14.7266C9.70378 14.7266 9.50359 14.6468 9.35059 14.4873C9.19759 14.3278 9.12109 14.1211 9.12109 13.8672V10.8008H6.06445C5.81055 10.8008 5.60221 10.7243 5.43945 10.5713C5.27669 10.4183 5.19531 10.2181 5.19531 9.9707Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_459_278">
        <rect width="19.9219" height="19.9316" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default plusIcon;
